const account = {
  '/account/update-pwd': '/user/security-setting/update-login-pwd',
  '/account/bind-email': '/user/security-setting/bind-email',
  '/account/update-mobile': '/user/security-setting/update-bind-mobile',
  '/account/google-auth': '/user/security-setting/google-auth/bind',
  '/account/capital-pwd/create': '/user/security-setting/capital-pwd/create',
  '/account/capital-pwd/update': '/user/security-setting/capital-pwd/update',
  '/account/capital-pwd/reset': '/user/security-setting/capital-pwd/reset'
}

const wallet = {
  '/wallet/recharge': '/user/wallet',
  '/wallet/withdraw': '/user/wallet',
  '/wallet/trade': '/user/wallet'
}

const user = {
  '/user/basic': '/user',
  '/user/account-security': '/user/security-setting',
  '/user/payment-setting': '/user/security-setting',
  '/user/event-subscribe': '/',
  '/user/court-order': '/user/order',
  '/user/loan-order': '/user/order',
  '/user/buy-ads': '/outside',
  '/user/selling-ads': '/outside',
  '/user/financing-ads': '/loan/financing',
  '/user/you-trust': '/user/trust-shield',
  '/user/trust-you': '/user/trust-shield',
  '/user/you-shield': '/user/trust-shield'
}

const paths = {
  ...account,
  ...wallet,
  ...user,
  '/forget': '/forget-pwd',
  '/invite': '/user/invite',
  '/advertise': '/outside/ad',
  '/loan/financing': '/loan/ad',
  '/trade': '/'
}

// 白名单
const whiteList = ['/quickBuy', '/quickBuy/confirm', '/quickBuy/search', '/purchase-agreement', '/statement-terms']

if (window.screen.width < 992 && !whiteList.includes(location.pathname)) {
  let protocol = location.protocol
  let search = location.search
  let pathname = location.pathname
  let routePath = pathname
  let host = location.host.replace(/(www.)?/, 'm.')

  if (pathname.startsWith('/loan/order', 0)) {
    routePath = pathname.replace('/order/', '/create-order/')
  } else if (pathname.startsWith('/order/details/', 0)) {
    routePath = pathname.replace('/order/details/', '/outside/trade/')
  } else if (pathname.startsWith('/order', 0)) {
    routePath = pathname.replace('/order/', '/outside/create-order/')
  } else if (pathname.startsWith('/user/auth/', 0)) {
    routePath = '/user/identity-auth'
  }

  if (paths[pathname]) {
    routePath = paths[pathname]
  }

  location.href = `${protocol}//${host}${routePath}${search}`
  // location.href = `${protocol}//127.0.0.1:8081${routePath}${search}`
}



// WEBPACK FOOTER //
// ./src/utils/paths.js